import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel"; // Added this
import FormControl from "@mui/material/FormControl"; // Added this
import clsx from "clsx";

interface DropDownFieldsProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  addStyle?: string;
  label: string;
  disabled?: boolean;
  addLabelStyle?: string;
}

const DropDownFields: React.FC<DropDownFieldsProps> = ({
  value,
  onChange,
  options,
  addStyle,
  addLabelStyle,
  label,
  disabled = false,
}) => {
  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl
      variant="outlined"
      sx={{
        borderRadius: 2,
        ".MuiOutlinedInput-root": {
          borderRadius: 0.5,
          "&.Mui-disabled": {
            color: "#556670",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
            "& .MuiSelect-icon": {
              display: "none", //
            },
          },
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#2C2C2C",
        },
        ".MuiFormLabel-root": {
          color: "#556670",
        },
      }}>
      <InputLabel htmlFor="label" className={addLabelStyle}>
        {label}
      </InputLabel>
      <Select
        label={label}
        id={label}
        value={value}
        onChange={handleDropdownChange}
        className={clsx(
          "!font-inter",
          "!h-[48px]",
          "!font-normal",
          "!text-[14px]",
          "!leading-[18px]",
          addStyle
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              ".MuiMenuItem-root": {
                height: "36px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "#F4F8F9 !important",
                },
              },
              ".MuiMenuItem-root.Mui-selected": {
                backgroundColor: "transparent !important",
                "&:hover": {
                  backgroundColor: "#F4F8F9 !important",
                },
              },
            },
          },
        }}
        disabled={disabled} // Added disabled prop to Select
      >
        {options.map((option) => (
          <MenuItem key={option} value={option} className="!font-inter">
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropDownFields;
